/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies, ember/require-tagless-components, warp-drive/no-create-record-rerender */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

export default class GoalGradeKey extends Component {
  @service
  session;

  @service
  store;

  @tracked subject = null;

  @computed('subject', 'session.activeSchool')
  get possibleGrades() {
    if (isEmpty(this.subject)) {
      // Create a temporary dummy subject to extract default grades from.
      let subject = this.store.createRecord('goals/subject', {
        schoolId: this.get('session.school'),
      });
      // Copy the possible grades into our own array.
      let possibleGrades = [...subject.possibleGrades];
      // Unload the record (it was never saved, so no need to delete/destroy).
      subject.unloadRecord();
      // Return our copy of the grades.
      return possibleGrades;
    }
    return this.subject.possibleGrades;
  }
}
